var formForProduct = document.querySelector('product-form');
var openBundle = getCookie('orthoticsDirect.openBundle');
var flag = document.querySelector('bundle-flag');

if(openBundle == "true"){
  openBundleUI();
}

function openBundleUI(){
  console.log(getCookie('orthoticsDirect.bundleProduct'));
  var bundleProduct = JSON.parse(getCookie('orthoticsDirect.bundleProduct'));
  var bundleProductTitle = getCookie('orthoticsDirect.bundleProductTitle');
  var productType = formForProduct && formForProduct.getAttribute('data-product-type');
  var bundleProductType = bundleProduct.properties.product_type;
  var productNeeded = bundleProduct.properties._product_needed;

  var flagState = getCookie('othorticsDirect.bundleFlag');
  console.log(flagState);
  formForProduct && formForProduct.setAttribute("data-bundle-id", bundleProduct.properties._bundle_id);

  const els = document.querySelectorAll('.active-bundle-ui');
  els.forEach(e =>{
    e.classList.add('active-bundle-ui--visible');
  });

  const titles = document.querySelectorAll('.product-name-ui');
  titles.forEach(e =>{
    e.innerHTML = bundleProductTitle;
  });

  const needs = document.querySelectorAll('.product-needed-ui');
  needs.forEach(e =>{
    e.innerHTML = productNeeded;
  });

  const fields = document.querySelectorAll('.bundle_field');
  fields.forEach(f =>{
    f.disabled = false;
  });

  if(bundleProductType == productType){
    var buttonsToShow = document.querySelectorAll('.bundling-need-other-product');
  }
  else if(bundleProductType != productType){
    var buttonsToShow = document.querySelectorAll('.bundling-need-this-product');
  }

  if(flagState == "closed"){
    flag.classList.remove("bundle-flag--open");
    flag.classList.add("bundle-flag--closed");
  }else{
    flag.classList.add("bundle-flag--open");
    flag.classList.remove("bundle-flag--closed");
  }

  buttonsToShow.forEach(e =>{
    e.classList.add('bundling--visible');
  });

  const elsToHide = document.querySelectorAll('.not-bundling');
  elsToHide.forEach(e =>{
    e.classList.add('hidden');
  });
}

function hideBundleUI(){
  formForProduct.removeAttribute("data-bundle-id");
  formForProduct.removeAttribute("bundling");
  document.querySelectorAll('.active-bundle-ui').forEach(e=>{
    e.classList.add('hidden');
    e.style.display = "none";
  });

  document.querySelectorAll('.bundling--visible').forEach(e=>{
    e.classList.remove('bundling--visible');
  });

  document.querySelectorAll('.no-bundle-ui').forEach(e=>{
    e.classList.remove('hidden');
    e.style.display = "block";
  });
};